




































import Vue from "vue";
import { TOTP_REGEX } from "@/constant/regex";

export default Vue.extend({
  props: ["onReadyToSubmit", "loading", "error"],
  watch: {
    totpCodeInput: {
      handler(value) {
        this.handleValueInput(value)
      },
      deep: true,
      immediate: true
    },
    error: {
      handler(value) {
        if (value) {
          this.totpCodeInput = ["", "", "", "", "", ""];
          try {
            this.$refs.inputContainer.getElementsByTagName('input')[0].focus();
          } catch (e) {
          }
        }
      }
    }
  },
  data() {
    return {
      focusNext: false,
      totpCodeInput: ["", "", "", "", "", ""],
      codeInputBefore: "",
    };
  },
  methods: {
    handleValueInput(otpDigitsInput) {
      for (const i of otpDigitsInput) {
        if (i.length === 6) {
          let key;
          key = i.substr(0, 6);
          const otpDigitsTemp = [...this.totpCodeInput];
          for (let j = 0; j < key.length; j++) {
            otpDigitsTemp[j] = key[j];
            this.totpCodeInput = [...otpDigitsTemp];
          }
          const otp = this.totpCodeInput.join("");
          this.onReadyToSubmit({ otp });
        }
      }
    },
    focus(event) {
      event.target.select();
      this.codeInputBefore = event.srcElement.value;
    },
    async focusNextInput(event, index) {
      const theEvent = event || window.event;
      const srcElement = theEvent.srcElement;
      const selectionStart = srcElement.selectionStart;
      const selectionEnd = srcElement.selectionEnd;
      let key = theEvent.keyCode || theEvent.which;
      if (key >= 96 && key <= 105) {
        // Numpad keys
        key -= 48;
      }
      const totpCodeInputTemp = [...this.totpCodeInput];
      key = String.fromCharCode(key);
      if (theEvent.keyCode === 8) {
        if (
          index > 0 &&
          (this.codeInputBefore.length === 0 ||
            this.codeInputBefore.length === totpCodeInputTemp[index].length)
        ) {
          this.$refs.field[index - 1].focus();
          this.totpCodeInput = totpCodeInputTemp;
          this.totpCodeInput[index - 1] = "";
          this.codeInputBefore = this.totpCodeInput[index - 1];
        } else {
          this.codeInputBefore = this.totpCodeInput[index];
        }
      } else if (theEvent.keyCode === 37) {
        if (index > 0) {
          this.$refs.field[index - 1].focus();
          this.codeInputBefore = this.totpCodeInput[index - 1];
        }
        return;
      } else if (theEvent.keyCode === 39) {
        if (index < 5) {
          this.$refs.field[index + 1].focus();
          this.codeInputBefore = this.totpCodeInput[index + 1];
        }
        return;
      } else if (theEvent.keyCode === 46) {
        if (
          index < 5 &&
          (this.codeInputBefore.length === 0 ||
            this.codeInputBefore.length === totpCodeInputTemp[index].length)
        ) {
          this.$refs.field[index + 1].focus();
          this.totpCodeInput = totpCodeInputTemp;
          this.totpCodeInput[index + 1] = "";
          this.codeInputBefore = this.totpCodeInput[index + 1];
        } else {
          this.codeInputBefore = this.totpCodeInput[index];
        }
      } else if (theEvent.ctrlKey && theEvent.code === "KeyV") {
        return;
      } else if (this.focusNext && TOTP_REGEX.test(key)) {
        if (index < 5 && this.totpCodeInput[index]) {
          this.$refs.field[index + 1].focus();
          this.codeInputBefore = this.totpCodeInput[index + 1];
        } else {
          this.codeInputBefore = this.totpCodeInput[index];
        }
      }
      const otp = this.totpCodeInput.join("");
      if (otp.length === 6) {
        this.onReadyToSubmit({ otp });
      }
    },
    validate(event, index) {
      this.codeInputBefore = this.totpCodeInput[index];
      const theEvent = event || window.event;
      const inputValue = this.totpCodeInput[index];
      const inputValueStr = String(inputValue);
      let key;
      // Handle paste
      if (theEvent.type === "paste") {
        theEvent.preventDefault();
        if (index !== 0) {
          return;
        }
        key = event.clipboardData.getData("text/plain");
        key = key.substr(0, 6);
      } else {
        // Handle key press
        key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }

      if (!TOTP_REGEX.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) {
          theEvent.preventDefault();
          this.focusNext = false;
          return;
        }
      }

      if (theEvent.type === "paste") {
        const totpCodeInputTemp = [...this.totpCodeInput];
        for (let i = 0; i < key.length; i++) {
          totpCodeInputTemp[i] = key[i];
          this.totpCodeInput = [...totpCodeInputTemp];
        }
        const indexNextInputForPaste = key.length;
        if (indexNextInputForPaste < 6) {
          this.$refs.field[indexNextInputForPaste].focus();
        } else {
          this.$refs.field[5].focus();
          const otp = this.totpCodeInput.join("");
        }
      } else {
        if (inputValueStr.length) {
          const totpCodeInputTemp = [...this.totpCodeInput];
          totpCodeInputTemp[index] = key[0];
          this.totpCodeInput = [...totpCodeInputTemp];
          theEvent.preventDefault();
        }
        this.focusNext = true;
      }
    },
  },
});
